var React = require('react');

function IconEPOnLocation (props) {
    return React.createElement("svg",props,React.createElement("path",{"data-name":"Path 3379","d":"M152.345 333.316c31.536 2.911 54.825 14.07 54.825 27.655 0 37.359-148.949 37.359-148.949 0 0-13.585 22.8-24.744 54.34-27.655 6.792 8.248 13.585 16.981 19.892 25.714 6.793-8.73 13.1-17.466 19.892-25.714zM132.453 0a132.313 132.313 0 01132.453 132.453c0 81.025-86.361 159.138-132.453 222.211C86.847 291.591 0 213.478 0 132.453 0 59.192 59.677 0 132.453 0zm0 46.577a85.876 85.876 0 1085.876 85.876 86.034 86.034 0 00-85.876-85.876z","fill":"#10457a","fillRule":"evenodd"}));
}

IconEPOnLocation.defaultProps = {"width":"264.906","height":"388.99","viewBox":"0 0 264.906 388.99"};

module.exports = IconEPOnLocation;

IconEPOnLocation.default = IconEPOnLocation;
